// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-user-view-dialog .fi-profile-view .fi-profile-view-data-list {
  margin-top: 0;
}
.fi-user-view-dialog .fi-profile-view-image .fi-profile-icon-img {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./Source/app/user/fi-user-view-dialog/fi-user-view-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR;AAEI;EACI,eAAA;AAAR","sourcesContent":[".fi-user-view-dialog {\r\n    .fi-profile-view .fi-profile-view-data-list {\r\n        margin-top: 0;\r\n    }\r\n    .fi-profile-view-image .fi-profile-icon-img {\r\n        cursor: pointer;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
